type ImageFocusSelectProps = {
  value: string;
  onChange: (value: string) => void;
};

const options = [
  { value: 'center', label: 'Center (default)' },
  { value: 'top', label: 'Top — keeps heads visible' },
  { value: 'bottom', label: 'Bottom' },
  { value: 'left', label: 'Left' },
  { value: 'right', label: 'Right' },
];

export function ImageFocusSelect({ value, onChange }: ImageFocusSelectProps) {
  return (
    <div className="space-y-1">
      <label className="text-sm font-medium">Crop focus point</label>
      <select
        value={value || 'center'}
        onChange={(e) => onChange(e.target.value)}
        className="w-full rounded-md border border-input bg-background px-3 py-2 text-sm"
      >
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
      <p className="text-xs text-muted-foreground">
        Controls where the image is cropped when displayed on the website.
      </p>
    </div>
  );
}
